import React from 'react';

import { Button, Icon } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { DebugToolModal, useDebugToolPosVendor } from 'components/debug-tool';
import { LoyaltyOffer, LoyaltyReward } from 'state/loyalty/types';

import { IncentiveDebug } from './incentive-debug';

interface IIncentiveDebugProps {
  incentive: LoyaltyOffer | LoyaltyReward;
}
interface IIncentiveDebugModalProps extends IIncentiveDebugProps {
  onClose: () => void;
}

const IncentiveDebugModal = ({ onClose, incentive }: IIncentiveDebugModalProps) => {
  const { storePosVendor } = useDebugToolPosVendor();

  return (
    <DebugToolModal onOpenEventMessage="Loyalty Debug Tool: Incentive detail" onClose={onClose}>
      <IncentiveDebug incentive={incentive} storePosVendor={storePosVendor} />
    </DebugToolModal>
  );
};

export const IncentiveDebugTool = (props: IIncentiveDebugProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <Button
        style={{ position: 'absolute', top: 0, left: 0, zIndex: 99999 }}
        variant="ghost"
        onPress={() => setIsModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
        marginY="$4"
      >
        <Typography>View Incentive{'\n'} info</Typography>
      </Button>

      {isModalOpen && <IncentiveDebugModal {...props} onClose={() => setIsModalOpen(false)} />}
    </>
  );
};
